import { useContext, useState } from "react";
import "./subscriptionForm.css";
import FormButton from "../dashboardComponents/FormButton";
import { DashboardContext } from "../../../contextApi/DashboardContext";
import { AppContext } from "../../../contextApi/ContextApi";
import { useNavigate } from "react-router-dom";


export default function SubscriptionForm({website}) {
    const {primary_color, secondary_color, accent_color, logout} = useContext(AppContext);
    const {handleDeleteWebsite} = useContext(DashboardContext);
    const [showMsg, setShowMsg] = useState(false);
    const nav = useNavigate();
    return (
        <div className="dashboardForm" dir="rtl">
            <h2>האם ברצונך למחוק את האתר ולהתנתק מהשירות של webingo?</h2>
            {showMsg ? <div className="dashboard_subscriptionForm_btnsContainer">
                <h3 style={{backgroundColor:primary_color, padding:"20px 5px", borderRadius:"10px"}}>אנחנו מחוייבים לשקף לך כי לאחר אישור פעולה זו תמחק את האתר וכל הנתונים השייכים לו יימחקו גם כן, אנו ממליצים לעדכן את לקוחותיך תחילה לפני אישור הפעולה ולוודא כי אין הזמנות פעילות של לקוחותיך על מנת להימנע מתביעות מיותרות, לחיצה על "אני בטוח" תאשר לנו את הסכמתך המלאה לביטול השירות בWebingo ומחיקת כל הנתונים שנמצאים אצלנו במערכת, האם אתה בטוח?</h3>
                <div className="dashboard_subscriptionForm_btnsDiv">
                    <button className="dashboard_subscriptionForm_btns_yes" onClick={()=>{handleDeleteWebsite(website, setShowMsg, logout, nav)}}>אני בטוח</button>    
                    <button className="dashboard_subscriptionForm_btns_no" onClick={()=>{setShowMsg(false)}}>אני רוצה להישאר</button>    
                </div>
            </div> : 
            <FormButton disabled={false} type={"button"} text={"תנתק אותי"} action={()=>{setShowMsg(true)}}/>
            }
        </div>
    )
}
